import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Modal from "react-modal";
import { Link } from "react-router-dom";

import {
  CreateFalseArray,
  ConnectStringandNum,
  CreateArrayAnswer,
  CreateArrayAnswerCorrect,
  CheckObject,
  CountWithFalse,
  CountWithFalseEnglish,
} from "../../Functions/functions";

import Checkbox from "../Checkbox/checkbox";

import "../../App.scss";
import Answer from "../Submit/Answer";

import Modal_image from "../Modal/Modal_image";

const Qzero = () => {
  console.log("Qzero");
  const [pets, setPets] = useState([]);

  const [imageModal, setImageModal] = useState({ open: false, url: "" });
  const [image, setImage] = useState([]);
  const [imageAlt, setImageAlt] = useState([]);
  const [finalImage, setFinalImage] = useState([]);
  const [finalImageAlt, setFinalImageAlt] = useState([]);
  const [description, setDescription] = useState([]);
  const [textCorrectAnswer, setTextCorrectAnswer] = useState([]);
  const [more_images1, setMoreImages1] = useState([]);
  const [more_images2, setMoreImages2] = useState([]);
  const [more_images3, setMoreImages3] = useState([]);
  const [more_images4, setMoreImages4] = useState([]);
  const [more_images_alt1, setMoreImagesAlt1] = useState([]);
  const [more_images_alt2, setMoreImagesAlt2] = useState([]);
  const [more_images_alt3, setMoreImagesAlt3] = useState([]);
  const [more_images_alt4, setMoreImagesAlt4] = useState([]);

  const [count, setCount] = useState(0);

  const [modalIsOpen, setIsOpen] = useState(false);

  // const [rand , setRand] = useState(count %2);
  const [rand, setRand] = useState(count);
  const [extraStep, setExtraStep] = useState([]);
  // console.log("[rand , setRand]: ", [rand , setRand]);

  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;
  var jsonData = {};
  var questionTitleClass = "";
  var answersClass = "";
  var backgrndTop1 = "";
  var bckgrndMain1 = "";
  var CongratsMessage = "";
  var QuestionGeneralInfo = "";
  var clickImage1 = "";
  var clickImage2 = "";
  var viewportWarning = "";
  var congratsMessage1 = "";
  var congratsMessage2 = "";
  var congratsNote = "";
  var congratsImage = "";
  const difficulty = useParams();

  if (gameLang === "en") {
    switch (difficulty.type) {
      case 'dimotiko':
        jsonData = require("../../Dimotiko.json");
        break;
      case 'lykeio':
        jsonData = require("../../Lykeio.json");
        break;
      default:
        jsonData = require("../../Dimotiko.json");
        break;
    }
    questionTitleClass = "question-title";
    answersClass = "answers";
    backgrndTop1 = "bckgrnd_top_1 bckgrnd_top_1_port";
    bckgrndMain1 = "bckgrnd_main_1 bckgrnd_main_1_port";
    CongratsMessage = "congrats_message set_narrow_width";
    QuestionGeneralInfo = "question-general-info do-not-display";
    clickImage1 = "Click on images";
    clickImage2 = "to enlarge them";
    viewportWarning =
      "In order to play this game, your viewport size has to be at least 700px wide and 525px high.";
    congratsMessage1 = "Well done!";
    congratsMessage2 =
      "You have built a basilica based on the archetype of Acheiropoietos in Thessaloniki.";
    congratsNote =
      "We would like to thank the Ephorate of Antiquities of the City of Thessaloniki and the archaeologist Dr Konstantinos Raptis for permission to use the photographs and plans of Acheiropoeitos.";
    congratsImage = "congrats_image";
  } else {
    switch (difficulty.type) {
      case 'dimotiko':
        jsonData = require("../../Dimotiko.json");
        break;
      case 'lykeio':
        jsonData = require("../../Lykeio.json");
        break;
      default:
        jsonData = require("../../Dimotiko.json");
        break;
    }
    questionTitleClass = "question-title";
    answersClass = "answers";
    backgrndTop1 = "bckgrnd_top_1 bckgrnd_top_1_port";
    bckgrndMain1 = "bckgrnd_main_1 bckgrnd_main_1_port";
    CongratsMessage = "congrats_message set_narrow_width";
    QuestionGeneralInfo = "question-general-info do-not-display";
    clickImage1 = "Κάνε κλικ για να δεις τις φωτογραφίες σε μεγέθυνση";
    clickImage2 = "";
    viewportWarning =
      "Για να μπορείτε να παίξετε το παιχνίδι απαιτούνται διαστάσεις οθόνης τουλάχιστον 700px πλάτος και 525px ύψος.";
    congratsMessage1 = "Συγχαρητήρια!";
    congratsMessage2 =
      "Συγχαρητήρια!";
    congratsNote =
      "Ολοκλήρωσες με επιτυχία το παιχνίδι.";
    congratsImage = "congrats_image";
  }

  const questionsLength = jsonData.Question.length;

  let ArrayAnswer = CreateArrayAnswer(
    jsonData.NumAnswer,
    jsonData,
    count,
    rand
  );
  let ObjectDataRow = CreateFalseArray(ArrayAnswer);
  let ArrayAnswerCorrect = CreateArrayAnswerCorrect(
    jsonData.NumAnswer,
    jsonData,
    count
  );
  // console.log("ArrayAnswer: " , ArrayAnswer)

  ObjectDataRow.AllAnswer = ArrayAnswer;
  const [isChecked, setIsChecked] = useState(ObjectDataRow.ArrayFalseTrue);

  CheckObject(ObjectDataRow, ArrayAnswerCorrect);

  function openModal(ev) {
    setIsOpen(true);
    ev.target.classList.add("darken_btn");
  }
  function afterOpenModal() {}
  function closeModal() {
    setIsOpen(false);
    setImageModal({ open: false, url: "" });
  }

  const [isChecked1, setIsChecked1] = useState([]);

  useEffect(() => {
    if (count < questionsLength) {
      requestPets();
    }
  }, [count]);

  const [lastQuestionAnswers, setLastQuestionAnswers] = useState([]);

  Modal.setAppElement(document.getElementById("root"));

  async function requestPets() {
    let min = 1;
    let max = 3;
    if (count < questionsLength && gameLang === "en") {
      setPets(jsonData.Question[count]);
      setImage(jsonData.QuestionImage[count]);
      setImageAlt(jsonData.QuestionImageAlt[count]);
      setFinalImage(jsonData.Final_Img[count]);
      setFinalImageAlt(jsonData.Final_Img_Alt[count]);
      setDescription(jsonData.QuestionDescription[count]);
      setTextCorrectAnswer(jsonData.TextCorrectAnswer[count]);
      setMoreImages1(jsonData.QuestionMoreImages1[count]);
      setMoreImages2(jsonData.QuestionMoreImages2[count]);
      setMoreImages3(jsonData.QuestionMoreImages3[count]);
      setMoreImages4(jsonData.QuestionMoreImages4[count]);
      setMoreImagesAlt1(jsonData.QuestionMoreImagesAlt1[count]);
      setMoreImagesAlt2(jsonData.QuestionMoreImagesAlt2[count]);
      setMoreImagesAlt3(jsonData.QuestionMoreImagesAlt3[count]);
      setMoreImagesAlt4(jsonData.QuestionMoreImagesAlt4[count]);
      setIsChecked1(CountWithFalseEnglish(count, jsonData));
      setRand(count);
      setExtraStep(jsonData.ExtraStep[count]);
    } else if (count < questionsLength && gameLang !== "en") {
      setPets(jsonData.Question[count]);
      setImage(jsonData.QuestionImage[count]);
      setImageAlt(jsonData.QuestionImageAlt[count]);
      setFinalImage(jsonData.Final_Img[count]);
      setFinalImageAlt(jsonData.Final_Img_Alt[count]);
      setDescription(jsonData.QuestionDescription[count]);
      setTextCorrectAnswer(jsonData.TextCorrectAnswer[count]);
      setMoreImages1(jsonData.QuestionMoreImages1[count]);
      setMoreImages2(jsonData.QuestionMoreImages2[count]);
      setMoreImages3(jsonData.QuestionMoreImages3[count]);
      setMoreImages4(jsonData.QuestionMoreImages4[count]);
      setMoreImagesAlt1(jsonData.QuestionMoreImagesAlt1[count]);
      setMoreImagesAlt2(jsonData.QuestionMoreImagesAlt2[count]);
      setMoreImagesAlt3(jsonData.QuestionMoreImagesAlt3[count]);
      setMoreImagesAlt4(jsonData.QuestionMoreImagesAlt4[count]);
      setIsChecked1(CountWithFalse(count, jsonData));
      setRand(count);
      setExtraStep(jsonData.ExtraStep[count]);
    }
  }

  function closeParentModal() {
    const parentDocument = window.parent.document;
    const closeButton = parentDocument.querySelector(".close-modal");
    const event = new Event("click");
    closeButton.dispatchEvent(event);
  }

  function handleNextQuestion() {
    // Save the current question's answers before moving to the next question
    setLastQuestionAnswers(ObjectDataRow.AllAnswer);

    // Move to the next question...
  }

  if (count <= questionsLength - 1) {
    return (
      <>
        <div
          onSubmit={(e) => {
            e.preventDefault();
            requestPets();
            handleNextQuestion();
          }}
        >
          <div className="gameplay">
            <div className="questions-container">
              <div className="question-and-answers">
                <div className="question">
                  <div className={questionTitleClass}>{pets}</div>
                </div>
                <form className={answersClass}>
                  {ObjectDataRow.AllAnswer.map((Answer1, index) => {
                    console.log(Answer1);
                    return (
                      <Checkbox
                        key={Answer1}
                        name={Answer1}
                        scount={setCount}
                        mycount={count}
                        Allcheck={isChecked1}
                        setChecked={setIsChecked1}
                        index={index}
                      />
                    );
                  })}
                  <Answer
                    setChecked={setIsChecked1}
                    mycheck={isChecked1}
                    defaultcheck={ObjectDataRow.ArrayZeroOne}
                    scount={setCount}
                    mycount={count}
                    extraStep={extraStep}
                    finalImage={finalImage}
                    finalImageAlt={finalImageAlt}
                    textCorrectAnswer={textCorrectAnswer}
                  />
                </form>
              </div>
              { (image !== "" || description !== "") && (
                <div className="question-image">
                  {image !== "" && <img src={`/games/wizard/img/${image}`} alt={imageAlt} loading="lazy" />}
                  {description !== "" && <p className="question-image-description">{description}</p>}
                </div>
              )}
              {more_images1 !== "" && (
                <div className="question-more-images">
                  {more_images1 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images1}`}
                        id="img1"
                        loading="lazy"
                        alt={more_images_alt1}
                        onClick={() => {
                          setImageModal({ open: true, url: more_images1 });
                        }}
                      />
                    </div>
                  ) : null}
                  {more_images2 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images2}`}
                        id="img2"
                        loading="lazy"
                        alt={more_images_alt2}
                        onClick={() => {
                          setImageModal({ open: true, url: more_images2 });
                        }}
                      />
                    </div>
                  ) : null}
                  {more_images3 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images3}`}
                        id="img3"
                        loading="lazy"
                        alt={more_images_alt3}
                        onClick={() => {
                          setImageModal({ open: true, url: more_images3 });
                        }}
                      />
                    </div>
                  ) : null}
                  {more_images4 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images4}`}
                        id="img4"
                        loading="lazy"
                        alt={more_images_alt4}
                        onClick={() => {
                          setImageModal({ open: true, url: more_images4 });
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal
          isOpen={imageModal.open}
          ariaHideApp={true}
          contentLabel="Enlarge Image"
          shouldCloseOnOverlayClick={true}
          portalClassName="modal_enlarge_image"
        >
          <div className="enlarged_image">
            <button
              className="close-image"
              onClick={() => {
                closeModal();
              }}
            >
              <svg width="20" height="20" viewBox="0 0 31.641 31.641">
                <g
                  id="Group_1116"
                  data-name="Group 1116"
                  transform="translate(-5333.215 -397.293)"
                >
                  <line
                    id="Line_311"
                    data-name="Line 311"
                    x2="30.226"
                    y2="30.226"
                    transform="translate(5333.922 398)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                  <line
                    id="Line_312"
                    data-name="Line 312"
                    x1="30.226"
                    y2="30.226"
                    transform="translate(5333.922 398)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </g>
              </svg>
            </button>
            <img src={`/games/wizard/img/${imageModal.url}`} />
          </div>
        </Modal>
      </>
    );
  } else {
    ObjectDataRow.AllAnswer = lastQuestionAnswers;
    console.log("lastQuestionAnswers: ", lastQuestionAnswers);
    return (
      <div>
        <div
          onSubmit={(e) => {
            e.preventDefault();
            requestPets();
          }}
        >
          <div className="gameplay">
            <div className="questions-container">
              <div className="question-and-answers">
                <div className="question">
                  <div className={questionTitleClass}>{pets}</div>
                </div>
                <form className={answersClass}>
                  {ObjectDataRow.AllAnswer.map((Answer1, index) => {
                    console.log(Answer1);
                    return (
                      <Checkbox
                        key={index}
                        name={Answer1}
                        scount={setCount}
                        mycount={count}
                        Allcheck={isChecked1}
                        setChecked={setIsChecked1}
                        index={index}
                      />
                    );
                  })}
                  <Answer
                    setChecked={setIsChecked1}
                    mycheck={isChecked1}
                    defaultcheck={ObjectDataRow.ArrayZeroOne}
                    scount={setCount}
                    mycount={count}
                    extraStep={extraStep}
                    finalImage={finalImage}
                    textCorrectAnswer={textCorrectAnswer}
                  />
                </form>
              </div>
              { (image !== "" || description !== "") && (
                <div className="question-image">
                  {image !== "" && <img src={`/games/wizard/img/${image}`} alt={imageAlt} />}
                  {description !== "" && <p className="question-image-description">{description}</p>}
                </div>
              )}
              {more_images1 !== "" && (
                <div className="question-more-images">
                  {more_images1 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images1}`}
                        id="img1"
                        onClick={() => {
                          setImageModal({ open: true, url: more_images1 });
                        }}
                      />
                    </div>
                  ) : null}
                  {more_images2 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images2}`}
                        id="img2"
                        onClick={() => {
                          setImageModal({ open: true, url: more_images2 });
                        }}
                      />
                    </div>
                  ) : null}
                  {more_images3 !== "" ? (
                    <div className="image-wrapper">
                      <img
                        src={`/games/wizard/img/${more_images3}`}
                        id="img3"
                        onClick={() => {
                          setImageModal({ open: true, url: more_images3 });
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal
          isOpen={true}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          contentLabel="Final Modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
          portalClassName="modal_final_message"
        >
          <div className="modal_container final">
            <div class="face_sketch">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="128"
                height="128"
                viewBox="0 0 128 128"
              >
                <g
                  id="Group_174"
                  data-name="Group 174"
                  transform="translate(-8229.25 -520.763)"
                >
                  <circle
                    id="Ellipse_61"
                    data-name="Ellipse 61"
                    cx="64"
                    cy="64"
                    r="64"
                    transform="translate(8229.25 520.763)"
                    fill="#e8e8e6"
                  />
                  <g id="Group_173" data-name="Group 173">
                    <path
                      id="Path_595"
                      data-name="Path 595"
                      d="M8293.25,547.063a36.9,36.9,0,1,1-36.9,36.9,36.951,36.951,0,0,1,36.9-36.9m0-3.6a40.5,40.5,0,1,0,40.5,40.5,40.446,40.446,0,0,0-40.5-40.5Zm17.1,30.15a6.29,6.29,0,0,1,6.03,4.5,5.812,5.812,0,0,0,.271-1.8,6.3,6.3,0,0,0-12.6,0,5.783,5.783,0,0,0,.271,1.8A6.29,6.29,0,0,1,8310.35,573.613Zm-33.3,0a6.292,6.292,0,0,1,6.03,4.5,5.812,5.812,0,0,0,.27-1.8,6.3,6.3,0,1,0-12.6,0,5.812,5.812,0,0,0,.27,1.8A6.292,6.292,0,0,1,8277.05,573.613Zm40.41,19.98a1.793,1.793,0,1,0-3.42-1.08,21.957,21.957,0,0,1-41.58-.09,1.793,1.793,0,1,0-3.42,1.08,25.536,25.536,0,0,0,48.42.09Z"
                      fill="#222"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div className="congrats_message">
              <div className="congrats_title"> {congratsMessage1} </div>
              <div className="congrats_note">{congratsNote}</div>
            </div>

            <a href="https://www.efamess.gr/paichnidia/" class="end-game">
              <span class="button-text">Παίξε ένα άλλο παιχνίδι</span>
            </a>
          </div>
        </Modal>
      </div>
    );
  }
};

export default Qzero;
